<template>
    <li class="nav-item dropdown">
        <a v-loading="loading" class="nav-icon dropdown-toggle" title="Ближайший приезд на площадку" href="#" id="informerNearestArrival" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="position-relative">
                <i class="fas fa-walking"></i>
                <span v-if="items.length" class="badge badge-danger counter">{{ items.length }}</span>
            </div>
        </a>
        <div v-if="items.length" class="dropdown-menu" aria-labelledby="informerNearestArrival">
            <router-link
                v-for="item in items"
                :key="item.id"
                :to="{ name: 'request', params: {id: item.id} }"
                class="dropdown-item"
            ><span class="text-primary">{{item.id}}</span> <span class="small text-muted">{{item.visit_date}}</span> <span>{{item.operator_name}}</span></router-link>
        </div>
    </li>
</template>

<script>
export default {
    name: "NearestArrival",
    data: () => ({
        items: [],
        interval: null,
        loading: true,
    }),
    async mounted() {
        await this.work();
        this.loading = false;
        this.interval = setInterval(this.work, 60000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        async work() {
            this.items = (await axios.get('/api/requests/nearest_arrival')).data;
        }
    }
}
</script>

<style scoped>
#informerNearestArrival .counter {
    font-size: 0.8rem;
    position: absolute;
    top: 2px;
    left: 15px;
    padding: 3px;
}
</style>
